export const setRef = (ref, value) => {
  if (ref) {
    ref.current = value;
  }
};
